// src/api/axiosInstance.ts
import axios from 'axios';
import { redirectToGoodLoka } from 'config/sso';
import { getAuthToken, localStorageService } from 'utils/localStorage';

// Créer une instance Axios
if (!process.env.REACT_APP_API_BASE_URL) throw new Error('REACT_APP_API_BASE_URL is not defined');

// Le backend Faritany expose désormais ses routes REST sous /api.
// REACT_APP_API_BASE_URL reste sans /api car il est aussi utilisé par socket.io
// (qui interpréterait un chemin dans l'URL comme un namespace).
const axiosInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASE_URL}/api`,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Intercepteur pour ajouter le token à chaque requête
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`; // Ajouter le token à l'en-tête Authorization
    }
    return config;
  },
  (error) => {
    // Gestion des erreurs de requête
    return Promise.reject(error);
  },
);

// Intercepteur pour gérer les réponses
axiosInstance.interceptors.response.use(
  (response) => {
    // Toute réponse réussie peut être gérée ici
    return response;
  },
  (error) => {
    // Gérer les erreurs de réponse ici
    if (error.response) {
      const { status } = error.response;

      if (status === 401) {
        localStorageService.removeItem('token');
        redirectToGoodLoka();
      }

      return Promise.reject({
        message: error.response.data?.message || 'Une erreur est survenue',
        status: status,
      });
    }

    // Si l'erreur n'a pas de réponse (erreur réseau par exemple)
    return Promise.reject(error);
  },
);

export default axiosInstance;
